import React from "react";

const SearchIcon = ({
  className,
  size = 18,
  color = "white",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M15.948 15.1623L13.1028 12.3171C14.0539 11.189 14.6295 9.7349 14.6295 8.1475C14.6295 4.57342 11.7221 1.66602 8.14798 1.66602C4.57391 1.66602 1.6665 4.57342 1.6665 8.1475C1.6665 11.7216 4.57391 14.629 8.14798 14.629C9.73539 14.629 11.1895 14.0534 12.3176 13.1023L15.1628 15.9475C15.2709 16.0556 15.4132 16.1105 15.5554 16.1105C15.6976 16.1105 15.8399 16.0564 15.948 15.9475C16.165 15.7312 16.165 15.3793 15.948 15.1623ZM2.77761 8.1475C2.77761 5.18602 5.1865 2.77713 8.14798 2.77713C11.1095 2.77713 13.5184 5.18602 13.5184 8.1475C13.5184 11.109 11.1095 13.5179 8.14798 13.5179C5.1865 13.5179 2.77761 11.109 2.77761 8.1475Z"
      fill={color}
    />
  </svg>
);

export default SearchIcon;
